// extracted by mini-css-extract-plugin
module.exports = {"fallbackImage":"styles_fallbackImage__1clI8","qrContainer":"styles_qrContainer__7649M"};